import { render } from "./PowerBISelectView.vue?vue&type=template&id=8801b604&scoped=true"
import script from "./PowerBISelectView.vue?vue&type=script&lang=js"
export * from "./PowerBISelectView.vue?vue&type=script&lang=js"

import "./PowerBISelectView.vue?vue&type=style&index=0&id=8801b604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8801b604"]])

export default __exports__